import InfoWidgetItemLayout, {
  InfoWidgetItemLayoutProps,
} from '../InfoWidgetItemLayout';
import Typography from '../../../library/Typography';
import { renderHTMLString } from '../../../../../../helpers';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';

interface InfoWidgetItemProps extends InfoWidgetItemLayoutProps {}

export default function InfoWidgetItemDefault(props: InfoWidgetItemProps) {
  const { icon, title, description, closeIcon, children } = props;

  const { location } = useRootSelector(selectPageConfig);

  return (
    <InfoWidgetItemLayout
      icon={icon}
      closeIcon={closeIcon}
      title={
        <Typography variant="body1" paletteColorName="brandSecondary">
          {title}
        </Typography>
      }
      description={
        description && (
          <Typography
            variant="smallText"
            neutralColorIndex={600}
            component="div"
          >
            {renderHTMLString(description, location)}
          </Typography>
        )
      }
    >
      {children}
    </InfoWidgetItemLayout>
  );
}
